module.exports = __webpack_public_path__ + "img/checkbox_active.9f42207c.svg";